const PlanSubscribeSteps = ({ active, changeActive }) => {
  return (
    <ul className="tikbox-steps tikbox-container">
      <li
        onClick={() => changeActive(1)}
        className={`tikbox-step active ${active === 1 ? 'current' : ''}`}>
        <span className="tikbox-step__title">Choose package</span>
        <span className="tikbox-step__value">1</span>
      </li>
      <li
        onClick={() => changeActive(2)}
        className={`tikbox-step ${active >= 2 ? 'active' : ''} ${
          active === 2 ? 'current' : ''
        }`}>
        <span className="tikbox-step__title">Order summary</span>
        <span className="tikbox-step__value">2</span>
      </li>
      <li
        className={`tikbox-step ${active >= 3 ? 'active' : ''} ${
          active === 3 ? 'current' : ''
        }`}>
        <span className="tikbox-step__title">Review & confirm</span>
        <span className="tikbox-step__value">3</span>
      </li>
    </ul>
  )
}
export default PlanSubscribeSteps
